module.exports = __webpack_public_path__ + "static/map-40ffdb360205f038eec59b94bd1010ed.png";